import React from 'react';

interface IconVignetteProps {
    width?: number | string;
    height?: number | string;
    color?: string;
}

const IconVignette: React.FC<IconVignetteProps> = ({
    width = 24,
    height = 24,
    color = 'black',
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <ellipse cx="12" cy="12" rx="10" ry="8" stroke={color} strokeWidth="2" />
        <ellipse cx="12" cy="12" rx="6" ry="4" stroke={color} strokeWidth="2" />
    </svg>
);

export default IconVignette;
